import {
  createSlice,
  createAsyncThunk,
  // autoBatchEnhancer,
} from "@reduxjs/toolkit";
import {
  AUTH_TOKEN,
  USERNAME,
  MODE,
  BRANCH,
  USERID,
  GETMENULIST,
  GETPROTECTEDROUTE,
  ROLE,
  SYSTEM_SETTINGS,
} from "constants/AuthConstant";
import { notification } from "antd";
import AuthService from "services/AuthService";
import { lmsClient } from "api";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  result: {},
  token: localStorage.getItem(AUTH_TOKEN) || null,
  role: localStorage.getItem(ROLE) || null,
};

export const signIn = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue, dispatch }) => {
    // const response = await AuthService.login(data);
    const response = [
      {
        key: "BUSINESS_DATE",
        value: "2026-05-27",
      },
    ];

    try {
      let userName = "";
      let roleId = "";

      switch (data.userId.toUpperCase()) {
        case "ATGADH2621":
          userName = "ABDULLAH";
          roleId = "los";
          break;
        case "GM200":
          userName = "Cahyo Saputra";
          roleId = "los";
          break;
        case "DIR200":
          userName = "Faisal Bustomi";
          roleId = "los";
          break;
        case "PRESDIR200":
          userName = "Alexandra";
          roleId = "los";
          break;
        case "STN":
          userName = "Santani";
          roleId = "los";
          break;
        case "IRMAN":
          userName = "Irman";
          roleId = "los";
          break;
        case "CA1":
          userName = "CA1";
          roleId = "los";
          break;
        case "CA2":
          userName = "CA2";
          roleId = "los";
          break;
        case "CA3":
          userName = "CA3";
          roleId = "los";
          break;
        case "CA4":
          userName = "CA4";
          roleId = "los";
          break;
        case "CALVIN":
          userName = "CALVIN";
          roleId = "lms";
          break;

        default:
          break;
      }

      const userBranchs = [
        {
          branchId: 900,
          branchName: "KANTOR PUSAT",
        },
        {
          branchId: 200,
          branchName: "JAKARTA",
        },
        {
          branchId: 201,
          branchName: "BANDUNG",
        },
      ];

      const token =
        "eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTUxMiIsInR5cCI6IkpXVCJ9.eyJJZCI6Ijc3MzJiZTg4LTQyM2ItNDI4YS1hMjA5LWZmNWUzMmVkMTA0NSIsInN1YiI6IlNhbnRhbmkiLCJlbWFpbCI6IlNhbnRhbmkiLCJqdGkiOiIzMGZhM2EzMS05NjRlLTQ2NzAtYWE4Yy0zZmUyYWYwZDU2MWQiLCJuYW1lIjoiU2FudGFuaSIsIkxvZ2luSWQiOiJTYW50YW5pIiwiZXhwIjoxNzE0MzYwNjY5LCJpc3MiOiJodHRwczovL2F1dGhfZmludHJ1c3RfYmUuY29tIiwiYXVkIjoiaHR0cHM6Ly9hcGlfZmludHJ1c3RfYmUuY29tIn0.zNCx29IAuE9L6flKyp4I0-T4NQ2hlP1Ei8NrYZRm_PYwdgHKLYx4j5IlnF6w9crb4k1njsVCHlM0CqJ6UjLXAg";

      localStorage.setItem(AUTH_TOKEN, token);
      localStorage.setItem(
        MODE,
        data.loginid && data.loginid.toLowerCase() === "admin"
          ? "am"
          : "cabang",
      );

      localStorage.setItem(USERID, data.userId);
      localStorage.setItem(USERNAME, userName);
      localStorage.setItem(ROLE, roleId);
      localStorage.setItem(SYSTEM_SETTINGS, JSON.stringify(response.data));
      notification.success({
        message: "Authentication Success",
        description: "You have been login successfully",
        duration: 3,
      });
      return {
        userBranchs, systemSettings: response.data
      };
    } catch (err) {
      console.log(err);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
    }

    //   const response = await AuthService.login(data);
    //   try {
    //     if (response.status === 201 || response.status === 200) {
    //       if (response.data.message == "Ok") {
    //         const { token, loginid } = response.data;
    //         localStorage.setItem(AUTH_TOKEN, token);
    //         localStorage.setItem(
    //           MODE,
    //           data.loginid && data.loginid.toLowerCase() === "admin"
    //             ? "am"
    //             : "cabang"
    //         );
    //         localStorage.setItem(USERID, data.userId);
    //         localStorage.setItem(USERNAME, loginid);

    //         notification.success({
    //           message: "Authentication Success",
    //           description: "You have been login successfully",
    //           duration: 3,
    //         });
    //       } else {
    //         notification.error({
    //           message: "Authentication Failed",
    //           description: response.data.Message,
    //           duration: 3,
    //         });
    //       }
    //       return response.data.branch || "No Response";
    //     } else {
    //       //Selain Response 200
    //       console.log("Selain Response 200");
    //       notification.error({
    //         message: "Error",
    //         description: "Unexpected response!",
    //         duration: 3,
    //       });
    //       return rejectWithValue({
    //         status: "Error",
    //         response: response?.data?.message || "Unexpected response!",
    //       });
    //     }
    //   } catch (err) {
    //     console.log("🚀 ~ error in signIn:", err);
    //     notification.error({
    //       message: "Error",
    //       description: "Unexpected response!",
    //       duration: 3,
    //     });
    //     return rejectWithValue(
    //       err.response?.data?.message || "Unexpected response!"
    //     );
    //   }
  },
);

export const fetchSystemSettings = createAsyncThunk(
  "auth/fetchSystemSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await lmsClient({ url: "/lms/systemsetting", method: "get" });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const signOut = createAsyncThunk("auth/logout", async () => {
  // const response = await AuthService.logout();
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(USERID);
  localStorage.removeItem(USERNAME);
  localStorage.removeItem(MODE);
  localStorage.removeItem(BRANCH);
  localStorage.removeItem(GETMENULIST);
  localStorage.removeItem(GETPROTECTEDROUTE);
  localStorage.removeItem(SYSTEM_SETTINGS);
  localStorage.removeItem(ROLE);
  notification.success({
    message: "Logout Success",
    description: "You have been logout successfully",
    duration: 3,
  });
  // return response;
  return "response";
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      localStorage.setItem(BRANCH, JSON.stringify(action.payload));
      state.token = localStorage.getItem(AUTH_TOKEN);
      state.role = localStorage.getItem(ROLE);
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.role = null;
      state.redirect = "/";
      state.selectedBranch = null;
      state.mode = null;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = localStorage.getItem(AUTH_TOKEN);
    },
    setUser: (state, action) => {
      state.userId = action.payload.userId;
      state.userBranch = action.payload.userBranch;
      state.userIduserId = action.payload.userIduserId;
    },
  },
  extraReducers: (builder) => {
    builder
      //signIn
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })

      //fetchSystemSettings
      .addCase(fetchSystemSettings.fulfilled, (state, action) => {
        state.result = { ...state.result, systemSettings: action.payload };
      })

      //signOut
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.role = null;
        state.selectedBranch = null;
        state.redirect = "/";
        state.userBranch = null;
        state.mode = null;
        state.result = {};
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
  setUser,
} = authSlice.actions;

export default authSlice.reducer;
